import { useEffect } from "react";

export const GoogleTranslate = () => {
  useEffect(() => {
    const addGoogleTranslateScript = () => {
      const script = document.createElement("script");
      script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    };

    if (!window.google || !window.google.translate) {
      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,ml",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false
          },
          "google_translate_element"
        );
        
        // Hide Google's UI after initialization
        setTimeout(() => {
          const googleTranslateElement = document.getElementById('google_translate_element');
          if (googleTranslateElement) {
            googleTranslateElement.style.display = 'none';
          }
        }, 1000);
      };
      addGoogleTranslateScript();
    }
  }, []);

  return (
    <div
      className={`w-14 h-14  cursor-pointer flex items-center justify-center text-white transform transition-all duration-300 hover:scale-110 hover:shadow-xl`}
      id="google_translate_element"
      style={{
      }}
    />
  );
}